// extracted by mini-css-extract-plugin
module.exports = {"disabledInput":"disabledInput___37d7J","Input":"Input___3jFnN","InputError":"InputError___1vMQv","FInputWordCount":"FInputWordCount___n35h5","beyond":"beyond___2tBDJ"};